import { Injectable } from "@angular/core";
import { NotificationService as KendoNotificationService } from "@progress/kendo-angular-notification";
import { first } from "rxjs/operators";
import { I18nService } from "../../i18n/services";
import { Notification, NotificationLevel } from "../notification";

@Injectable({
  providedIn: "root"
})
export class NotificationService {
  constructor(
    private translate: I18nService,
    private notificationService: KendoNotificationService
  ) {}

  public default(content: string, hideAfter?: number): void {
    this.show({ content, hideAfter, level: "none" });
  }

  public error(content: string, hideAfter?: number): void {
    this.show({ content, hideAfter, level: "error" });
  }

  public info(content: string, hideAfter?: number): void {
    this.show({ content, hideAfter, level: "info" });
  }

  public show(notification: Notification): void {
    this.showInternal(
      notification.content,
      notification.hideAfter,
      notification.level
    );
  }

  private showInternal(
    content: string,
    hideAfter?: number,
    type?: NotificationLevel
  ): void {
    this.translate
      .get(content)
      .pipe(first()) // unsubscribe automatically when their condition is me
      .subscribe((msg) =>
        this.notificationService.show({
          content: msg,
          hideAfter,
          position: { horizontal: "center", vertical: "top" },
          animation: { type: "fade", duration: 400 },
          type: { style: type, icon: true }
        })
      );
  }

  public success(content: string, hideAfter?: number): void {
    this.show({ content, hideAfter, level: "success" });
  }

  public warning(content: string, hideAfter?: number): void {
    this.show({ content, hideAfter, level: "warning" });
  }
}
